import {action, observable} from 'mobx';
import {accountTypes} from '../SignInStore';
import { signUp } from '@/services/SignUp';
import stores from '@/stores';
import log from '@/utils/log';

export type paramsTypes = accountTypes & {code: string}

class SignUpStore {
  
  @observable userAccount: paramsTypes = {
        mobile: '',
        password: '',
        code: ''
    };
  
  @action.bound async SignUp () {
      const [error] = await signUp(this.userAccount);
      if (error) {
        log({pageId: 'P02', eventId: 'E0205',ext: ''})
        return
      }
    log({pageId: 'P02', eventId: 'E0206',ext: ''})
    stores.routingStore.history.push('/');
  }
  
  @action.bound setUserAccount(userAccount: { [key: string]: string }) {
      this.userAccount = Object.assign({}, this.userAccount, userAccount);
  }
  
  
}

export default SignUpStore;
